import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function RedirectGuard() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const fullPath =
      location.pathname + location.search + location.hash;

    if (fullPath.includes("undefined")) {
      navigate("/", { replace: true }); 
    }
  }, [location, navigate]);

  return null;
}